import { defineNuxtRouteMiddleware, navigateTo, useRequestEvent } from '#imports'
import { hasAuth0Cookie } from '#shared/utils/hasAuth0Cookie'
import { useAuthService } from '@b2ag/auth'
import { getAppContext } from '@b2ag/micro-front-tools'
import { parseCookies } from 'h3'
import { useLogger } from '@b2ag/utils/src/useLogger'
import { cleanForceLoginFromPath } from '../helpers/cleanForceLoginFromPath'

const logger = useLogger()

export const privateMethods = {
  get isBrowser() {
    return import.meta.browser
  },
  get isServer() {
    return import.meta.server
  },
}

function hasForceLogin(to: any): boolean {
  return String(to.query?.forceLogin).toLowerCase() === 'true'
}

function mustBeConnected(to: any) {
  return to.meta.private || hasForceLogin(to) || getAppContext().isFrontTech
}

export default defineNuxtRouteMiddleware(async (to) => {
  const redirectTo =
    !to.meta.doNotStoreRoute || to.meta.storePathBeforeAuth ? cleanForceLoginFromPath(to.fullPath) : undefined
  if (privateMethods.isServer && mustBeConnected(to) && !to.meta.oauthWorkflow) {
    const event = useRequestEvent()

    if (!event) return Promise.resolve()

    if (!hasAuth0Cookie(parseCookies(event))) {
      return navigateTo(
        {
          name: 'login',
          query: { redirectTo },
        },
        { redirectCode: 401 },
      )
    } else if (hasForceLogin(to)) {
      return navigateTo(cleanForceLoginFromPath(to.fullPath), { replace: true })
    }
  } else if (privateMethods.isBrowser && !to.meta.oauthWorkflow) {
    const authService = useAuthService()

    // Attention isAuthenticated() ne vérifie pas l'expiration de l'access token, mais cette véfirication est faite
    // dans le middleware 05.authentication-check.global.ts

    if (mustBeConnected(to) && !(await authService.isAuthenticated())) {
      // Utilisateur déconnecté tentant d'accéder à une page privée
      logger.info('trying to access a private route without being connected. Redirecting to login page.')
      return navigateTo({ name: 'login', query: { redirectTo } })
    } else if (hasForceLogin(to)) {
      return navigateTo(cleanForceLoginFromPath(to.fullPath), { replace: true })
    }
  }
})
